var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 4C0.666016 1.79086 2.45688 0 4.66602 0H6.66602V1.33333H4.66602C3.19326 1.33333 1.99935 2.52724 1.99935 4C1.99935 5.47276 3.19326 6.66667 4.66602 6.66667H6.66602V8H4.66602C2.45688 8 0.666016 6.20914 0.666016 4Z",
    fill: "#697180"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 0H11.3327C13.3147 0 14.96 1.44152 15.2774 3.33333H15.3327V4C15.3327 6.20914 13.5418 8 11.3327 8H9.33268V6.66667H11.3327C12.8054 6.66667 13.9993 5.47276 13.9993 4C13.9993 2.52724 12.8054 1.33333 11.3327 1.33333H9.33268V0Z",
    fill: "#697180"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 3.33333L11.3327 3.33333V4.66667H4.66602V3.33333Z",
    fill: "#697180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.44379e0fe7661b6410a97e14e95e40af.svg";
export { ForwardRef as ReactComponent };